export default __webpack_public_path__ + "vendor/ckeditor/skins/moono-lisa/readme.md";